import { h, JSX } from 'preact';

import { DeleteIcon } from './Icons';

export interface DeleteButtonProps {
    onClick: () => void;
}

export const DeleteButton = (props: DeleteButtonProps): JSX.Element => (
    <button class='block transition rounded-full hover:bg-neutral-100' onClick={props.onClick}>
        <DeleteIcon class='block' />
    </button>
);
